import React, { useState, createContext, useCallback, useEffect } from "react";

import { PContext, PaymentState } from "./types";

const initialState: PaymentState = {
    enabled: undefined,
    amount: undefined,
    tipAmount: undefined,
    id: undefined,
    note: undefined,
    paymentQrSrc: undefined,
    paymentUrl: undefined,
    status: undefined,
    recipient: undefined,
    paymentMethod: undefined,
};

export const PaymentContext = createContext({} as PContext);

export const PaymentProvider = ({ children }: { children: any }) => {
    const [paymentState, setPaymentState] =
        useState<PaymentState>(initialState);

    const resetPaymentState = useCallback(() => {
        setPaymentState(initialState);
    }, []);

    const updatePaymentState = useCallback((args: Partial<PaymentState>) => {
        setPaymentState((prevState) => ({ ...prevState, ...args }));
    }, []);

    useEffect(() => {
        console.log("paymentState", paymentState);
    }, [paymentState]);

    return (
        <PaymentContext.Provider
            value={{ paymentState, resetPaymentState, updatePaymentState }}
        >
            {children}
        </PaymentContext.Provider>
    );
};
